import { PluginKey } from 'prosemirror-state';
export var fakeCursorForToolbarPluginKey = new PluginKey('fakeCursorToolbarPlugin');
//# sourceMappingURL=fake-curor-for-toolbar-plugin-key.js.map